import * as React from 'react';

import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import styles from './SEShipmentCard.styles';
import GetExecutionData from 'src/dto/response/getExecution';
import { rfqTypesNames } from 'src/utils/utils';
import { Icon, Tooltip, message, Menu, Dropdown, Checkbox, Form } from 'antd';
import { ModesOfService , OrgTypes } from 'src/Library/Constants';
import { stops } from 'src/Library/Helper';
import { editShipmentWatcher } from 'src/api/shipmentExecution';
import { MilestoneCodes, ProcurementType, isBreakBulkMode } from '../SE.constants';
import { setSelectedShipments } from 'src/actions/shipmentExecutionActions';
const FCLIcon = require('src/assets/images/FCL.svg');
const LCLIcon = require('src/assets/images/LCL.svg');
const AirIcon = require('src/assets/images/Air.svg');
const BreakBulkIcon = require('src/assets/images/breakbulk-crane-crate-black.svg');
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DomesticTruckIcon from 'src/components/common/icons/DomesticTruckIcon';

export interface SEShipmentCardProps extends StylesProps<ReturnType<typeof styles>> {
  cardData: GetExecutionData;
  selectedShipment: GetExecutionData;
  onClickCard: () => void;
  taskSummary: Record<string, number>;
  userEmail: string;
  toggleShipmentWatch: (params) => void;
  index: number;
  key: string;
  selectedShipments: Record<string, GetExecutionData>;
  setSelectedShipments: (selectedShipments: Record<string, GetExecutionData>) => void;
  do_not_show_supplier?: boolean;
  show_creator?: boolean;
  showRoadInsteadOfDomestic?: boolean;
}

const SEShipmentCard: React.FC<SEShipmentCardProps> = (props) => {
  const {
    classes,
    cardData,
    selectedShipment,
    onClickCard,
    taskSummary,
    toggleShipmentWatch,
    index,
    key,
    selectedShipments,
    setSelectedShipments,
    do_not_show_supplier,
    show_creator,
  } = props;

  const [watching, setWatching] = React.useState(false);

  const getModeIcon = () => {
    if (isBreakBulkMode(cardData.mode)) {
      return BreakBulkIcon;
    }
    switch (cardData.mode) {
      case ModesOfService.FCL:
        return FCLIcon;
      case ModesOfService.LCL:
      case ModesOfService.RPTL:
        return LCLIcon;
      default:
        return AirIcon;
    }
  };

  const getTotal = () => {
    const count = Object.keys(taskSummary || {}).reduce((acc, cur) => {
      acc = acc + taskSummary[cur];
      return acc;
    }, 0);
    return count || '0';
  };

  const renderStats = () => {
    const totalTask = getTotal();
    return (
      <Tooltip title="Tasks Completed">
        <div className={classes.tasks}>
          <Icon type="carry-out" theme="twoTone" />
          <div>
            <span
              className={classes.tasksCompleted}
              data-card-completed-task={taskSummary?.Done || '0'}
            >
              {taskSummary?.Done || '0'}
            </span>
            <span data-card-total-task={totalTask}>/{totalTask}</span>
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderFlag = () => {
    const milestoneLabel = MilestoneCodes[cardData.milestone]?.label;
    const flagStyle = {
      backgroundColor:
        milestoneLabel === 'On Hold' ? '#FEC89A ' : '#FEF9E9',
    };
    const iconType = milestoneLabel === 'On Hold' ? 'pause-circle' : 'flag';
    return (
      <Tooltip title="Current Milestone">
        <div className={classes.currentMilestone} style={flagStyle}>
          <Icon type={iconType} style={{ marginRight: 2 }} />
          <div data-card-milestone={milestoneLabel || '-'}>
            {milestoneLabel}
          </div>
        </div>
      </Tooltip>
    );
  };
  const toggleWatching = async (e) => {
    stops(e);
    setWatching(true);
    const { cardData, userEmail } = props;
    const { isWatching, watcherList, id: shipmentId } = cardData;
    let newWatcherList;
    if (isWatching) newWatcherList = watcherList?.filter((watcher) => watcher !== userEmail);
    else {
      newWatcherList = watcherList?.length ? watcherList.concat(userEmail) : [userEmail];
    }
    const response = await editShipmentWatcher(shipmentId, {
      watcherList: newWatcherList,
    });
    if (response.isSuccess) {
      toggleShipmentWatch({
        index: props.index,
        watcherList: newWatcherList,
        isWatching: !isWatching,
      });
    } else {
      message.error(response.errorMessage);
    }
    setWatching(false);
  };

  const watchingText = () => {
    return (
      <div style={{ textAlign: 'center', fontSize: '10px' }}>
        Click to be a Watcher <br /> for this Shipment.
      </div>
    );
  };

  const watcherListDiv = () => {
    return (
      <div style={{ fontSize: '10px' }} data-card-watcher-list={`${cardData?.id}_watcherList`}>
        {cardData?.watcherList?.length ? (
          <div
            style={{
              borderBottom: '0.5px solid #DFDCDC',
            }}
          >
            <span
              style={{
                color: '#C8F3FF',
                textDecoration: 'underline',
              }}
            >
              People who are watching :
            </span>
            <ul
              style={{
                padding: '8px 0px 10px 10px',
                margin: 0,
                listStyleType: 'decimal',
              }}
            >
              {cardData?.watcherList?.map((watcher) => (
                <li data-card-watcher-id={watcher}>{watcher}</li>
              ))}
            </ul>
          </div>
        ) : null}
        <div style={{ textAlign: 'center', paddingTop: '4px' }}>
          Click again to stop being a <br /> watcher for this Shipment.
        </div>
      </div>
    );
  };

  const renderWatcher = () => {
    return (
      <Tooltip title={cardData?.isWatching ? watcherListDiv() : watchingText()}>
        <Icon
          style={{
            color: cardData?.isWatching ? 'black' : 'lightgrey',
            display: 'flex',
            alignItems: 'center',
          }}
          type={cardData?.isWatching ? 'eye' : 'eye-invisible'}
          onClick={toggleWatching}
          data-card-watcher-eye={`${cardData?.id}_watcherEye`}
        />
      </Tooltip>
    );
  };

  const renderRight = () => {
    return (
      <div className={classes.bodyRight}>
        {renderFlag()}
        {renderStats()}
        {renderWatcher()}
      </div>
    );
  };

  const renderLeft = () => {
    return (
      <div className={cardData.mode === ModesOfService.DOMESTIC ? classes.bodyLeftDomestic : classes.bodyLeft}>
        {renderOrigin()}
        {renderLine()}
        {renderDestination()}
      </div>
    );
  };

  const renderContainerList = () => {
    const { containerList } = cardData;
    if (containerList?.length) {
      const containerMenuList = containerList.map((containerNumber) => (
        <Menu.Item key={containerNumber} className={classes.containerNumbers}>
          <div className={classes.dotMenu}>.</div>
          <div data-card-container-number={containerNumber}>{containerNumber}</div>
        </Menu.Item>
      ));
      const containerMenu = (
        <Menu>
          <Menu.Item className={classes.containerNumberLabel} key="containerNumber">
            Container Number{containerList.length > 1 ? 's' : ''}
          </Menu.Item>
          {containerMenuList}
        </Menu>
      );
      return (
        <Dropdown
          overlayClassName={classes.customContainerNumberDropdown}
          overlay={containerMenu}
          trigger={['click']}
          getPopupContainer={(trigger: any) => trigger.parentNode}
        >
          <div
            className={classes.containerListLabel}
            data-card-container-list={containerList.length}
          >
            {containerList.length} Container{containerList.length > 1 ? 's' : ''}
          </div>
        </Dropdown>
      );
    }
    return '';
  };

  const renderStakeholderList = (orgType) => {
    const stakeholderNames =
      orgType === OrgTypes.SUPPLIER
        ? cardData.supplierNames
        : cardData.customerNames;
    const stakeholderLabel = orgType === OrgTypes.SUPPLIER ? 'Supplier' : 'Customer';
  
    // If there's nothing, return empty.
    if (!stakeholderNames?.length) {
      return '';
    }
  
    // If exactly one name, just display the text (no dropdown).
    if (stakeholderNames.length === 1) {
      const [singleName] = stakeholderNames;
      return (
        <div className={classes.containerListLabel}>
          {stakeholderLabel}: {singleName}x
        </div>
      );
    }
  
    // If more than one name, display a dropdown menu.
    const stakeholderMenuList = stakeholderNames.map((name) => (
      <Menu.Item key={name} className={classes.containerNumbers}>
        <div className={classes.dotMenu}>.</div>
        {orgType === OrgTypes.SUPPLIER ? (
          <div data-card-supplier-name={name}>{name}</div>
        ) : (
          <div data-card-customer-name={name}>{name}</div>
        )}
      </Menu.Item>
    ));
  
    const stakeholderMenu = (
      <Menu>
        <Menu.Item
          className={classes.containerNumberLabel}
          key={orgType === OrgTypes.SUPPLIER ? 'supplierName' : 'customerName'}
        >
          {stakeholderLabel}
          {stakeholderNames.length > 1 ? 's' : ''}
        </Menu.Item>
        {stakeholderMenuList}
      </Menu>
    );
  
    const listName =
      orgType === OrgTypes.SUPPLIER
        ? 'data-card-supplier-list'
        : 'data-card-customer-list';
  
    return (
      <Dropdown
        overlayClassName={classes.customContainerNumberDropdown}
        overlay={stakeholderMenu}
        trigger={['click']}
        getPopupContainer={(trigger: any) => trigger.parentNode}
      >
        <div
          className={classes.containerListLabel}
          {...{ [listName]: stakeholderNames.length }}
        >
          {stakeholderNames.length} {stakeholderLabel}
          {stakeholderNames.length > 1 ? 's' : ''}
        </div>
      </Dropdown>
    );
  };
  

  const renderSupplierContainerList = () => {
    const { type } = cardData;

    switch (type) {
      case 'IMPORT':
        return (
          renderStakeholderList(OrgTypes.SUPPLIER)
        )
      case 'EXPORT':
        return (
          renderStakeholderList(OrgTypes.CUSTOMER)
        )
      case 'TRADE':
        return (
          <>
          {renderStakeholderList(OrgTypes.SUPPLIER)}
          {cardData?.supplierNames?.length ? '|' : ''}
          {renderStakeholderList(OrgTypes.CUSTOMER)}
          </>
        )
    }
    return undefined;
  };

  const renderApiResponse = () => {
    const { extraData } = cardData;

    if (!extraData?.message) {
      return null;
    }

    return (
      <Tooltip title={extraData?.apiResponseMessage || extraData?.message}>
        <div
          className={classes.alertMessage}
          style={{
            backgroundColor: extraData?.apiStatus ? '#46B774' : '#F75555',
            borderRight: '1px solid',
          }}
        >
          <div className={classes.apiResponseMessage} data-card-message={`${cardData.id}_message`}>
            {extraData?.message}
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderAlerts = () => {
    const dueToday = Boolean(Number(cardData.tasksDueTodayCount))
      ? cardData.tasksDueTodayCount + ' Task(s) Due Today'
      : undefined;
    const overdue = Boolean(Number(cardData.tasksOverdueCount))
      ? cardData.tasksOverdueCount + ' Task(s) Overdue'
      : undefined;
    const msgCount = Boolean(Number(cardData.commentCount))
      ? cardData.commentCount + ' Message(s)'
      : undefined;
    const all = [
      ...(dueToday ? [dueToday] : []),
      ...(overdue ? [overdue] : []),
      ...(msgCount ? [msgCount] : []),
    ];

    if (!dueToday && !overdue && !msgCount) {
      return null;
    }

    const alertText = all.join(' | ');

    return (
      <div
        className={classes.alertMessage}
        style={cardData.extraData?.message ? { borderRadius: 0 } : {}}
        data-card-alerts={alertText}
      >
        {alertText}
      </div>
    );
  };

  const renderCargoType = () => {
    return (
      <div className={classes.cargoType}>
        {cardData?.cargoType && (
          <>
            <span data-card-cargo-type={cardData.cargoType}>{cardData.cargoType}&nbsp;</span>
            {
              cardData.cargoSubtype ? <Tooltip title={cardData.cargoSubtype}>
                <div data-card-cargo-subtype={cardData.cargoSubtype}
                style = {{maxWidth: '150px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}
                >|{cardData.cargoSubtype}</div>
              </Tooltip> : ''
            }
          </>
        )}
        <span style={{display: 'flex'}}>
          {cardData?.cargoType ? '|' : ''}
          {renderSupplierContainerList()}
        </span>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className={classes.footer}>
        {renderCargoType()}
        <div style={{ display: 'flex' }}>
          {renderContainerList()}
          {renderApiResponse()}
          {renderAlerts()}
        </div>
      </div>
    );
  };

  const renderOrigin = () => {
    let title = cardData.originPortName;
    let portCode = cardData.originPortCode;
    let portName = cardData.originPortName;
    const roadBasedModes = cardData.mode === ModesOfService.DOMESTIC || cardData.mode === ModesOfService.RPTL;
    if (roadBasedModes) {
      title = [
        cardData?.originLocationDetails?.name, 
        cardData?.originLocationDetails?.address, 
        cardData?.originLocationDetails?.landmark, 
        cardData?.originLocationDetails?.city, 
        cardData?.originLocationDetails?.state, 
        cardData?.originLocationDetails?.countryName, 
        cardData?.originLocationDetails?.pincode
      ].filter((val) => val).join(', ');
      portCode = cardData.originLocationDetails?.city?.toUpperCase() || cardData.originLocationDetails?.name?.toUpperCase();
      portName = cardData.originLocationDetails?.pincode || cardData.originLocationDetails?.address;
    }
    return (
      <Tooltip title={title}>
        <div className={roadBasedModes ? classes.originDestinationDomestic : classes.originDestination}>
          <div
            className={classes.originDestinationCode}
            data-card-origin-code={portCode || 'N/A'}
          >
            {' '}
            {portCode || 'N/A'}{' '}
          </div>
          <div
            className={classes.originDestinationName}
            data-card-origin-name={portName || 'N/A'}
          >
            {' '}
            {portName || 'N/A'}{' '}
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderDestination = () => {
    let title = cardData.destinationPortName;
    let portCode = cardData.destinationPortCode;
    let portName = cardData.destinationPortName;
    const roadBasedModes = cardData.mode === ModesOfService.DOMESTIC || cardData.mode === ModesOfService.RPTL;
    if (roadBasedModes) {
      title = [
        cardData?.destinationLocationDetails?.name, 
        cardData?.destinationLocationDetails?.address, 
        cardData?.destinationLocationDetails?.landmark, 
        cardData?.destinationLocationDetails?.city, 
        cardData?.destinationLocationDetails?.state, 
        cardData?.destinationLocationDetails?.countryName, 
        cardData?.destinationLocationDetails?.pincode
      ].filter((val) => val).join(', ');
      portCode = cardData.destinationLocationDetails?.city?.toUpperCase() || cardData.destinationLocationDetails?.name?.toUpperCase();
      portName = cardData.destinationLocationDetails?.pincode || cardData.destinationLocationDetails?.address;
    }
    return (
      <Tooltip title={title}>
        <div className={roadBasedModes ? classes.originDestinationDomestic : classes.originDestination}>
          <div
            className={classes.originDestinationCode}
            data-card-destination-code={portCode || 'N/A'}
          >
            {' '}
            {portCode || 'N/A'}{' '}
          </div>
          <div
            className={classes.originDestinationName}
            data-card-destination-name={portName || 'N/A'}
          >
            {' '}
            {portName || 'N/A'}{' '}
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderLine = () => {
    return <div className={classes.line}></div>;
  };

  const renderLogo = () => {
    return cardData.carrierLogoUrl ? (
      <img
        src={cardData.carrierLogoUrl}
        style={{ maxWidth: '105px' }}
        data-card-logo={`${cardData.id}_logo`}
        alt={`Carrier logo`}
      />
    ) : null;
  };

  const renderBody = () => {
    return (
      <div className={classes.body}>
        {renderLeft()}
        {renderLogo()}
        {renderRight()}
      </div>
    );
  };

  const renderSupplierAndFF = () => {
    // If we don't want to show the supplier, bail out right away
    if (do_not_show_supplier) {
      return null;
    }
  else {
    return (
      <div className={classes.supplierFFDiv}>
        <Tooltip title={cardData.supplierName}>
          <span
            className={classes.supplierFFName}
            data-card-supplier-name={cardData.supplierName}
          >
            {cardData.supplierName}
          </span>
        </Tooltip>
        {cardData.supplierName && (
          <span style={{ margin: '0 4px' }}>|</span>
        )}
        <Tooltip title={cardData.ffName}>
          <span
            className={classes.supplierFFName}
            data-card-ffName={cardData.ffName || (cardData.supplierName && '-')}
          >
            {cardData.ffName || (cardData.supplierName && '-')}
          </span>
        </Tooltip>
      </div>
    );
  }
  };
  

  const renderMode = () => {
    return (
      <div className={classes.mode}>
        {cardData.mode === ModesOfService.DOMESTIC && 
          <DomesticTruckIcon 
            strokeColor={'#000'} 
            fill={'#000'} 
            style={{ marginRight: 6 }}
            aria-label={`${props?.showRoadInsteadOfDomestic ? 'Road' : 'Domestic'} transport mode icon`}
          />}
        {cardData.mode !== ModesOfService.DOMESTIC && 
          <img 
            src={getModeIcon()} 
            style={{ marginRight: 6 }} 
            alt={`${cardData.mode} transport mode icon`}
          />}
        <span style={{ fontWeight: 600 }} data-card-mode={cardData.mode}>
          {cardData.mode === ModesOfService.DOMESTIC && props?.showRoadInsteadOfDomestic 
            ? 'Road' 
            : cardData.mode}
        </span>
      </div>
    );
  };

  const handleChangeSelection =(isSelected: boolean) => {
    const newSelection = { ...selectedShipments };
    const id = cardData.id;

    if (isSelected)
      newSelection[id] =  cardData;
    else
      delete newSelection[id];

    setSelectedShipments(newSelection);
  }

  const renderCheckbox = () => {
    return (
      <div style={{marginRight:'5px'}}>
        <Checkbox
        checked={!!selectedShipments[cardData.id]}
        onChange={(e) => handleChangeSelection(e.target.checked)}
      />
      </div>
    );
  };

  const renderReference = () => {
    return (
      <div className={classes.headerLeft}>
        {renderCheckbox()}
        <Tooltip title={cardData.masterReferenceNumber}>
          <div
            data-master-reference-number={cardData.masterReferenceNumber}
            className={`${classes.referenceNumber} ${classes.ellipsis}`}
          >
            {cardData.masterReferenceNumber}
          </div>
        </Tooltip>
        {/* <Tooltip title={cardData.clientReferenceNumber}> */}
        <div className={`${classes.internalNumber} ${classes.ellipsis}`}>
          {/* {cardData.clientReferenceNumber === cardData.referenceNumber ? '' : cardData.clientReferenceNumber} */}
        </div>
        {/* </Tooltip> */}
        {show_creator && (
          <Tooltip title={cardData?.userName}>
            <span
              className={classes.supplierFFName}
              data-card-supplier-name={cardData.supplierName}
            >
              {cardData?.userName} 
            </span>
          </Tooltip>
        )}
        {renderMode()}
        <div className={classes.blackDot}></div>
        <div className={classes.type} data-card-type={cardData.type}>
          {rfqTypesNames[cardData.type]}
        </div>
        {(cardData.mode !== ModesOfService.DOMESTIC && cardData.mode !== ModesOfService.RPTL) && cardData.incoterm && <div className={classes.blackDot}></div>}
        <div className={classes.type} data-card-incoterm={cardData.incoterm}>
          {(cardData.mode !== ModesOfService.DOMESTIC && cardData.mode !== ModesOfService.RPTL) ? cardData.incoterm : ''}
        </div>
        {renderSpotBadge()}
      </div>
    );
  };

  const renderSpotBadge = () => {
    if (cardData.procurementType !== ProcurementType.SPOT) {
      return null;
    }
    return (
      <div className={classes.spotBadge} data-card-procurement-type={cardData.procurementType}>
        Spot
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div className={classes.header}>
        {renderReference()}
        {renderSupplierAndFF()}
      </div>
    );
  };

  return (
    <div
      onClick={onClickCard}
      data-card-id={cardData.id}
      className={`${classes.parentDiv} ${
        selectedShipment.id === cardData.id ? classes.selectedShipment : ''
      } ${Object.keys(selectedShipments).length > 0 ? null : classes.cardHover}`}
    >
      {renderHeader()}
      {renderBody()}
      {renderFooter()}
    </div>
  );
};

const mapStateToProps = ({ shipmentExecutionReducer, masterData }, ownProps) => {

  return {
    selectedShipments: shipmentExecutionReducer.selectedShipments,
    do_not_show_supplier: masterData?.execution?.doNotShowSupplier,
    show_creator: masterData?.execution?.showCreator,
    showRoadInsteadOfDomestic: masterData?.modules?.show_road_instead_of_domestic,
    
  };
};

const mapDispatchToProps = dispatch => (bindActionCreators({
  setSelectedShipments,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Form.create()(React.memo(SEShipmentCard))));
